function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMouthSpreechless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M109.202 101.482C122.538 96.204 132 83.19 132 68c0-19.85-16.15-36-36-36S60 48.15 60 68c0 15.19 9.462 28.204 22.798 33.482C56.047 107.514 36 131.452 36 160h8c0-28.673 23.327-52 52-52s52 23.327 52 52h8c0-28.547-20.047-52.486-46.798-58.518zM68 68c0-15.44 12.56-28 28-28s28 12.56 28 28-12.56 28-28 28-28-12.56-28-28zm20 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm16 0a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm-8 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8z",
    style: {
      fill: "#000000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMouthSpreechless);
export default __webpack_public_path__ + "static/media/user-mouth-spreechless.6e7711d5a65fec3b07e6e05b5e568715.svg";
export { ForwardRef as ReactComponent };